module.exports = __webpack_public_path__ + "static/media/MB_ProviderPortal_2@2x.cd9d87de.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/medibank/MB_ProviderPortal_2@2x.png
// module id = 217
// module chunks = 0